import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "app",
  initialState: {
    notifText: null,
    projectData: [
      {
        img: "proj_pics/nsutx.png",
        longImg: "proj_pics/nsutx_long.png",
        title: "NSUTx",
        desc: "An app that all students of NSUT use for any access to personal/academic data, faculty and student schedules, syllabi and previous year papers, and more.",
        longDesc:
          "An app that all students of NSUT use for any access to personal/academic data, faculty and student schedules, syllabi and previous year papers, and more.\n\nThis is an active project, developed by DevComm (prev. IOSD), a student society in the Netaji Subhas University of Technology. I was a part of the student council, and worked alongside highly talented and motivated people to develop this app.",
        skills: ["Flutter", "Dart", "Cross Platform Development"],
        keywords: ["app-development", "cross-platform-app"],
        date: "May 2021 - Feb 2022",
        createdAt: "NSUT",
        externalLink:
          "https://play.google.com/store/apps/details?id=com.devcomm.nsutx&hl=en&gl=US",
      },
      {
        img: "/proj_pics/paradox.png",
        longImg: "/proj_pics/paradox_long.png",
        title: "Paradox",
        desc: "A system to perform one among a set of some predefined actions based on a voice-based user input.",
        longDesc:
          "A system to perform one among a set of some predefined actions based on a voice-based user input.\n\nParadox is designed to be used in smart IoT systems. It consumes low power for its operation, and is small enough to fit in a Raspberry Pi. It gets activated by a trigger word, and listens to a command. Then, it applies a best-effort algorithm to match that command to one of its pre-defined tasks, and executes that task when a confident match is found.",
        skills: ["Tensorflow", "Deep Learning", "Python", "JS", "TinyML"],
        keywords: ["iot", "deep-learning", "semantic-similarity", "tiny-ml"],
        date: "Feb 2023 - Apr 2023",
        createdAt: "NSUT",
        externalLink: "https://github.com/rohan843/Paradox",
      },
      {
        img: "proj_pics/gameera.jpg",
        longImg: "proj_pics/gameera_long.png",
        title: "Game Era",
        desc: "A project showing the use of recommender systems in an online game store.",
        longDesc:
          "A project showing the use of recommender systems in an online game store.\n\nThis project uses various methodologies such as feature extraction, k-nearest neighbors, collaborative filtering, content-based filtering, user action monitoring and more to present the visitors with personalized game and friend recommendations.",
        skills: ["Python", "Flask", "NodeJS", "JS", "Machine Learning"],
        keywords: [
          "content-based-filtering",
          "collaborative-filtering",
          "recommender-systems",
          "machine-learning",
          "server-development",
          "e-commerce",
        ],
        date: "May 2022 - Jul 2022",
        createdAt: "NSUT",
        externalLink: "https://github.com/rohan843/GameRecommenderEngine",
      },
      {
        img: "proj_pics/flipkart_cyberspace.png",
        longImg: "proj_pics/flipkart_cyberspace_long.png",
        title: "Flipkart Cyberspace",
        desc: "A virtual and immersive store, right on your screen! This project demonstrates the use of metaverse and VR technology to provide shoppers an enhanced experience.",
        longDesc:
          "A virtual and immersive store, right on your screen! This project demonstrates the use of metaverse and VR technology to provide shoppers an enhanced experience.\n\nThis project was created in Flipkart Grid 4.0 Hackathon. It uses the Decentraland SDK, which comes with in-built interoperability with the blockchain-based decentraland metaverse.",
        skills: ["DecentralandSDK", "JavaScript", "VR", "Web 3.0"],
        keywords: [
          "decentraland",
          "metaverse",
          "e-commerce",
          "non-immersive-virtual-reality",
          "blockchain",
        ],
        date: "Jun 2022 - Jul 2022",
        createdAt: "NSUT",
        externalLink: "https://github.com/rohan843/FlipkartCyberspace",
      },
    ],
    activeProject: null,
    resumeLink:
      "https://drive.google.com/file/d/1OcKc2qsvZzEqZIGqddFBO7ZtMTFZK7D1/view?usp=sharing",
    showResumeLink: false,
    makeResumeLinkFlashy: true,
    showSocialLinksFullyLabelled: false,
    /**
     * The timeline must be sorted as follows:
     *  1. The thing that started the earliest must come to the lowermost position.
     *  2. If 2 things started at the same time, the one that ended the earliest comes lower than
     *     the one that ended later.
     */
    timelineData: [
      {
        title: "Summer Internship",
        org: "American Express",
        date: "May 2023 - Jul 2023",
        desc: "I took part in AmEx's summer internship program of 2023. I worked closely with different internal teams on various critical tasks.",
        link: "https://drive.google.com/file/d/1rdW7J6pRHwF-JzQ58RNTADNrlQLxn_-6/view?usp=drive_link&usp=embed_facebook",
      },
      {
        title: "Student Council - App Dev Team",
        org: "DevComm (prev. IOSD)",
        date: "2021 - 2023",
        desc: "I was a member of the student council at DevComm, the largest tech. society at NSUT. I took part in multiple projects that we undertook, notably the NSUTx app.",
        link: "https://devcomm.international/",
      },
      {
        title: "Major in Computer Science and Engineering",
        org: "Netaji Subhas University of Technology",
        date: "2020 - 2024",
        desc: "I pursued a degree in B.Tech. Computer Science and Engineering at NSUT from 2020 to 2024. I took various courses ranging from domains of theoretical computer science and software development to domains such as HCI.",
      },
    ],
    activeSection: "about",
    testimonialsData: [
      {
        id: 1,
        pic: "testimonial_pics/shivam.png",
        name: "Shivam Mittal",
        desgn: "Digital Product Analyst at American Express",
        text: "[...]Rohan joined our organization as an intern and quickly became an integral part of our team. He demonstrated an exceptional understanding of Python programming and showed a strong ability to apply his knowledge to solve complex coding challenges. He consistently delivered high-quality code and contributed significantly to the success of several projects and automations.[...]",
        link: "https://www.linkedin.com/in/rohan-sharma-323593202/#:~:text=Given-,Shivam%20Mittal,July%2014%2C%202023%2C%20Shivam%20was%20Rohan%E2%80%99s%20mentor,-July%2014%2C%202023",
      },
    ],
    skills: {
      Node: "https://nodejs.org/en",
      "C++": "https://cplusplus.com/",
      Python: "https://www.python.org/",
      JavaScript: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
      TensorFlow: "https://www.tensorflow.org/",
      Flask: "https://flask.palletsprojects.com/en/3.0.x/",
      Hive: "https://hive.apache.org/",
      SQL: "https://en.wikipedia.org/wiki/SQL",
      git: "https://git-scm.com/",
      React: "https://react.dev/",
      Tailwind: "https://tailwindcss.com/",
    },
  },
  reducers: {
    setNotifTo(state, action) {
      state.notifText = action.payload;
    },
    setActiveProject(state, action) {
      state.activeProject = action.payload;
    },
    setActiveSection(state, action) {
      state.activeSection = action.payload;
      /**
       * Resume should be accessible hereon.
       */
      if (
        !state.showResumeLink &&
        (state.activeSection === "experience" ||
          state.activeSection === "contact")
      ) {
        state.makeResumeLinkFlashy = false;
        state.showResumeLink = true;
      }
    },
    toggleSocialLinksLabels(state) {
      state.showSocialLinksFullyLabelled = !state.showSocialLinksFullyLabelled;
    },
    activateResumeLink(state) {
      state.showResumeLink = true;
    },
  },
});

export const appReducer = appSlice.reducer;
export const {
  setNotifTo,
  setActiveProject,
  setActiveSection,
  toggleSocialLinksLabels,
  activateResumeLink,
} = appSlice.actions;
